import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class GetSimulatedInstantOfferSellerUseCase extends UseCase {
  constructor({httpRepository, localStorageRepository, rawParamsToGetSimulatedInstantOfferRequestMapper}) {
    super()

    this._httpRepository = httpRepository
    this._localStorageRepository = localStorageRepository
    this._rawParamsToGetSimulatedInstantOfferRequestMapper = rawParamsToGetSimulatedInstantOfferRequestMapper
  }

  @tracer({metric: 'GetSimulatedInstantOfferSellerUseCase#execute'})
  @inlineError
  execute({
    bodyTypeDoors,
    fuelId,
    km,
    makeId,
    makeName,
    modelId,
    modelName,
    postalCode,
    transmissionTypeId,
    versionId,
    versionName,
    year
  } = {}) {
    const requestFields = {
      bodyTypeDoors,
      fuelId,
      km,
      makeId,
      makeName,
      modelId,
      modelName,
      postalCode,
      transmissionTypeId,
      versionId,
      versionName,
      year
    }

    const getSimulatedInstantOfferRequest = this._rawParamsToGetSimulatedInstantOfferRequestMapper.map(requestFields)

    return this._httpRepository
      .getSimulatedInstantOffer({
        getSimulatedInstantOfferRequest
      })
      .then(async ([error, instantOfferVO]) => {
        if (error) return Promise.reject(error)
        return instantOfferVO.toJSON()
      })
  }
}
